import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { providePrimeNG } from 'primeng/config';
import { definePreset } from '@primeuix/themes';
import Lara from '@primeuix/themes/lara';

// Marca JM Biomédica (azul oscuro / medio / claro, RGB del cliente)
const BrandPreset = definePreset(Lara, {
  semantic: {
    primary: {
      50: '#dae7f6',
      100: '#c3d8f0',
      200: '#9cbfe5',
      300: '#6ea3d8',
      400: '#438bc9',
      500: '#407cb8',
      600: '#3d6da7',
      700: '#3a5e97',
      800: '#374f86',
      900: '#344075',
      950: '#2c3663',
    },
  },
});
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth/interceptors/auth.interceptor';
import { environment } from '../environments/environment';
import { MessageService, ConfirmationService } from 'primeng/api';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptor])),
    MessageService,
    ConfirmationService,
    providePrimeNG({
      theme: {
        preset: BrandPreset,
        options: {
          darkModeSelector: false
        }
      }
    }),
    provideTranslateService({
      fallbackLang: 'es'
    }),
    provideTranslateHttpLoader({
      prefix: './assets/i18n/',
      suffix: `.json?v=${environment.i18nVersion}`
    })
  ]
};
